import { unmaskNumber } from '@givebutter/util';
import { NewContactId } from 'assets/js/pages/contacts/ContactForm';
import { SoftCreditFormValues } from 'assets/js/pages/transactions/soft-credits/types';
import { SoftCreditParams } from 'types/domain';

const transformSoftCreditToUpstream = (
    values: SoftCreditFormValues['softCredit'],
): SoftCreditParams => {
    const {
        selectedContact,
        firstName,
        lastName,
        emails,
        phones,
        amount,
        note,
        contactType,
        companyName,
    } = values;
    const selectedContactId = selectedContact[0];
    const isNewContact = selectedContact[0] === NewContactId;

    return {
        contact_id: isNewContact ? undefined : parseInt(selectedContactId),
        contact: isNewContact
            ? {
                  first_name: firstName,
                  last_name: lastName,
                  company_name: companyName,
                  emails: emails.filter(email => !!email.value),
                  phones: phones.filter(phone => !!phone.value),
                  type: contactType,
              }
            : undefined,
        amount: unmaskNumber(amount),
        note: note,
    };
};

export { transformSoftCreditToUpstream };
